module.exports = __webpack_public_path__ + "img/lz.8e4e86c8.jpg";